import React, { useState } from 'react';

import ContactsSpinner from '../components/ContactsSpinner';
import Merges from '../components/Merges';
import { useErrorContext } from '../contexts/ErrorContext';
import { useContactsContext } from '../contexts/ContactsContext';
import { ContentContainer, ScrollableContent } from '../components/styled';

import { TAppContact } from 'TProtocol/common/models';

function Review() {
  const errorContext = useErrorContext();
  const contactsContext = useContactsContext();
  const [errorLoadingContacts] = useState<boolean>(false);

  const onClickMergeSuggestion = (mergeSuggestionId: string) => {

    if (mergeSuggestionId == 'all') {
      contactsContext.setLCM(new Map<string, TAppContact[]>());
    } else {
      const mergeSuggestions = new Map<string, TAppContact[]>(contactsContext.LCM);
      const deleted = mergeSuggestions.delete(mergeSuggestionId);
      if (deleted) {
        contactsContext.setLCM(mergeSuggestions);
      } else {
        errorContext.error('Did not find merge suggestion to dismiss.');
      }
    }
  };

  return (
    <ContentContainer>
      <ScrollableContent>
        {
          !contactsContext.LCM ? <>
              {errorLoadingContacts ? errorLoadingContacts : <div className="mt-3"><ContactsSpinner/></div>}
            </> :
            (contactsContext.LCM.size > 0 ?
              <Merges onClickMergeSuggestion={onClickMergeSuggestion}/> :
              <div>There are currently no merge suggestions for you</div>)
        }
      </ScrollableContent>
    </ContentContainer>
  );
}

export default Review;


